export default "__VITE_ASSET__5c98893d__"